import { name, version, code } from '../package.json'
import routers from './router'
import components from './components'
import api from './api'
import config from './config/index'
import stores from './store/index'
import './style/index.scss'
export const TdPenalize = { name, code, version, components, routers, api, config, stores }
export default TdPenalize
